import { render, staticRenderFns } from "./InfoBase.vue?vue&type=template&id=932038a4&scoped=true&"
import script from "./InfoBase.vue?vue&type=script&lang=js&"
export * from "./InfoBase.vue?vue&type=script&lang=js&"
import style0 from "./InfoBase.vue?vue&type=style&index=0&id=932038a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932038a4",
  null
  
)

export default component.exports